export const BUSINESS_CATEGORY_EEM = 'EEM'
export const BUSINESS_CATEGORY_PROVIDER = 'PROVIDER'

export const BUSINESS_STATUS_PRIVATE = 'PRIVATE'
export const BUSINESS_STATUS_PUBLIC = 'PUBLIC'

export const BUSINESS_USER_TYPE_ANONYME = 'ANONYME'
export const BUSINESS_USER_TYPE_BUSINESS_ADMIN = 'BUSINESS_ADMIN'
export const BUSINESS_USER_TYPE_BUSINESS_EDITOR = 'BUSINESS_EDITOR'
export const BUSINESS_USER_TYPE_GLOBAL_EDITOR = 'GLOBAL_EDITOR'
export const BUSINESS_USER_TYPE_PROJECT_EDITOR = 'PROJECT_EDITOR'

export const CONTENT_LANGUAGE_ENGLISH = 'ENGLISH'
export const CONTENT_LANGUAGE_FRENCH = 'FRENCH'

export const LOG_LEVEL_INFORMATION = 'Information'
export const LOG_LEVEL_WARNING = 'Warning'
export const LOG_LEVEL_ERROR = 'Error'
export const LOG_LEVEL_CRITICAL = 'Critical'

export const NOTIFICATION_TYPE_INFO = 'info'
export const NOTIFICATION_TYPE_WARNING = 'warning '
export const NOTIFICATION_TYPE_ERROR = 'error'
export const NOTIFICATION_TYPE_SUCCESS = 'success'

export const PROJECT_STATUS_ACTIVE = 'ACTIVE'
export const PROJECT_STATUS_FINISH = 'FINISH'
export const PROJECT_STATUS_INACTIVE = 'INACTIVE'

export const PROJECT_SORT_DEFAULT = 'DEFAULT'
export const PROJECT_SORT_CREATED_AT = 'CREATED_AT'
export const PROJECT_SORT_NAME = 'NAME'
export const PROJECT_SORT_PROVINCE_CODE = 'PROVINCE_CODE'

export const SORT_ORDER_ASC = 'ASC'
export const SORT_ORDER_DESC = 'DESC'

export const TOKEN_STATUS_INVALID = 'INVALID'
export const TOKEN_STATUS_USER_CONFIRMED = 'CONFIRMED'
export const TOKEN_STATUS_VALID = 'VALID'

export const TOKEN_TYPE_CONFIRM_EMAIL = 'CONFIRM_EMAIL'
export const TOKEN_TYPE_CREATE_USER = 'CREATE_USER'
export const TOKEN_TYPE_RESET_PASSWORD = 'RESET_PASSWORD'

export const USER_TYPE_ANONYME = 'ANONYME'
export const USER_TYPE_SYSTEM_ADMIN = 'SYSTEM_ADMIN'
export const USER_TYPE_USER = 'USER'

export const INDICATOR_TYPE_GENERAL = 'GENERAL'
export const INDICATOR_TYPE_PROJECT = 'PROJECT'

export const INDICATOR_DIFFICULTY_UNSET = 'UNSET'
export const INDICATOR_DIFFICULTY_EASY = 'EASY'
export const INDICATOR_DIFFICULTY_MEDIUM = 'MEDIUM'
export const INDICATOR_DIFFICULTY_HARD = 'HARD'

export const INDICATOR_STATUS_TODO = 'TODO'
export const INDICATOR_STATUS_IN_PROGRESS = 'IN_PROGRESS'
export const INDICATOR_STATUS_DONE = 'DONE'
export const INDICATOR_STATUS_NOT_APPLICABLE = 'NOT_APPLICABLE'
export const INDICATOR_STATUS_OVERRIDE_NEVER_APPLICABLE = 'OVERRIDE_NEVER_APPLICABLE'

export const INDICATOR_TARGET_DATE_UNSET = 'UNSET'
export const INDICATOR_TARGET_DATE_LATE = 'LATE'
export const INDICATOR_TARGET_DATE_UPCOMING = 'UPCOMING'

export const INDICATOR_JUSTIFICATION_NOT_APPLICABLE_TO_BUSINESS_ACTIVITIES = 'NOT_APPLICABLE_TO_BUSINESS_ACTIVITIES'
export const INDICATOR_JUSTIFICATION_NOT_YET_REQUIRED_FOR_BUSINESS_ACTIVITIES = 'NOT_YET_REQUIRED_FOR_BUSINESS_ACTIVITIES'
export const INDICATOR_JUSTIFICATION_NOT_APPLICABLE_TO_PRIVATE_BUSINESSES = 'NOT_APPLICABLE_TO_PRIVATE_BUSINESSES'
export const INDICATOR_JUSTIFICATION_NOT_APPLICABLE_TO_EXPLORATION_BUSINESSES = 'NOT_APPLICABLE_TO_EXPLORATION_BUSINESSES'
export const INDICATOR_JUSTIFICATION_NOT_APPLICABLE_TO_SUPPLIERS = 'NOT_APPLICABLE_TO_SUPPLIERS'
export const INDICATOR_JUSTIFICATION_SUPPLIER_NOT_REPRESENTATIVE_TO_NATIVE_COMMUNITIES =
  'SUPPLIER_NOT_REPRESENTATIVE_TO_NATIVE_COMMUNITIES'
export const INDICATOR_JUSTIFICATION_SUPPLIER_NOT_REPRESENTATIVE_TO_STAKEHOLDERS = 'SUPPLIER_NOT_REPRESENTATIVE_TO_STAKEHOLDERS'
export const INDICATOR_JUSTIFICATION_SUPPLIER_NOT_REPRESENTATIVE_TO_LOCAL_AUTHORITIES =
  'SUPPLIER_NOT_REPRESENTATIVE_TO_LOCAL_AUTHORITIES'
export const INDICATOR_JUSTIFICATION_SUPPLIER_NOT_REPRESENTATIVE_TO_GOVERNMENT_AUTHORITIES =
  'SUPPLIER_NOT_REPRESENTATIVE_TO_GOVERNMENT_AUTHORITIES'
export const INDICATOR_JUSTIFICATION_SUPPLIER_NOT_RESPONSIBLE_FOR_TERRITORIAL_CONSTRAINTS =
  'SUPPLIER_NOT_RESPONSIBLE_FOR_TERRITORIAL_CONSTRAINTS'
export const INDICATOR_JUSTIFICATION_PROJECT_DOES_NOT_AFFECT_NATIVE_COMMUNITIES = 'PROJECT_DOES_NOT_AFFECT_NATIVE_COMMUNITIES'
export const INDICATOR_JUSTIFICATION_PROJECT_DOES_NOT_AFFECT_STAKEHOLDERS = 'PROJECT_DOES_NOT_AFFECT_STAKEHOLDERS'
export const INDICATOR_JUSTIFICATION_PROJECT_NOT_LOCATED_ON_LOCAL_AUTHORITY_TERRITORY =
  'PROJECT_NOT_LOCATED_ON_LOCAL_AUTHORITY_TERRITORY'
export const INDICATOR_JUSTIFICATION_OTHER_REASON = 'OTHER_REASON'

export const IndicatorJustifications_All = [
  INDICATOR_JUSTIFICATION_NOT_APPLICABLE_TO_BUSINESS_ACTIVITIES,
  INDICATOR_JUSTIFICATION_NOT_YET_REQUIRED_FOR_BUSINESS_ACTIVITIES,
  INDICATOR_JUSTIFICATION_NOT_APPLICABLE_TO_PRIVATE_BUSINESSES,
  INDICATOR_JUSTIFICATION_NOT_APPLICABLE_TO_EXPLORATION_BUSINESSES,
  INDICATOR_JUSTIFICATION_NOT_APPLICABLE_TO_SUPPLIERS,
  INDICATOR_JUSTIFICATION_SUPPLIER_NOT_REPRESENTATIVE_TO_NATIVE_COMMUNITIES,
  INDICATOR_JUSTIFICATION_SUPPLIER_NOT_REPRESENTATIVE_TO_STAKEHOLDERS,
  INDICATOR_JUSTIFICATION_SUPPLIER_NOT_REPRESENTATIVE_TO_LOCAL_AUTHORITIES,
  INDICATOR_JUSTIFICATION_SUPPLIER_NOT_REPRESENTATIVE_TO_GOVERNMENT_AUTHORITIES,
  INDICATOR_JUSTIFICATION_SUPPLIER_NOT_RESPONSIBLE_FOR_TERRITORIAL_CONSTRAINTS,
  INDICATOR_JUSTIFICATION_PROJECT_DOES_NOT_AFFECT_NATIVE_COMMUNITIES,
  INDICATOR_JUSTIFICATION_PROJECT_DOES_NOT_AFFECT_STAKEHOLDERS,
  INDICATOR_JUSTIFICATION_PROJECT_NOT_LOCATED_ON_LOCAL_AUTHORITY_TERRITORY,
  INDICATOR_JUSTIFICATION_OTHER_REASON
]

export const IndicatorJustifications_General_EEM = [
  INDICATOR_JUSTIFICATION_NOT_APPLICABLE_TO_BUSINESS_ACTIVITIES,
  INDICATOR_JUSTIFICATION_NOT_APPLICABLE_TO_PRIVATE_BUSINESSES,
  INDICATOR_JUSTIFICATION_NOT_APPLICABLE_TO_EXPLORATION_BUSINESSES,
  INDICATOR_JUSTIFICATION_OTHER_REASON
]
export const IndicatorJustifications_General_FS = [
  INDICATOR_JUSTIFICATION_NOT_APPLICABLE_TO_BUSINESS_ACTIVITIES,
  INDICATOR_JUSTIFICATION_NOT_APPLICABLE_TO_PRIVATE_BUSINESSES,
  INDICATOR_JUSTIFICATION_NOT_APPLICABLE_TO_SUPPLIERS,
  INDICATOR_JUSTIFICATION_OTHER_REASON
]
export const IndicatorJustifications_Project_EEM = [
  INDICATOR_JUSTIFICATION_NOT_APPLICABLE_TO_BUSINESS_ACTIVITIES,
  INDICATOR_JUSTIFICATION_NOT_YET_REQUIRED_FOR_BUSINESS_ACTIVITIES,
  INDICATOR_JUSTIFICATION_NOT_APPLICABLE_TO_EXPLORATION_BUSINESSES,
  INDICATOR_JUSTIFICATION_PROJECT_DOES_NOT_AFFECT_NATIVE_COMMUNITIES,
  INDICATOR_JUSTIFICATION_PROJECT_DOES_NOT_AFFECT_STAKEHOLDERS,
  INDICATOR_JUSTIFICATION_PROJECT_NOT_LOCATED_ON_LOCAL_AUTHORITY_TERRITORY,
  INDICATOR_JUSTIFICATION_OTHER_REASON
]
export const IndicatorJustifications_Project_FS = [
  INDICATOR_JUSTIFICATION_NOT_APPLICABLE_TO_BUSINESS_ACTIVITIES,
  INDICATOR_JUSTIFICATION_NOT_YET_REQUIRED_FOR_BUSINESS_ACTIVITIES,
  INDICATOR_JUSTIFICATION_NOT_APPLICABLE_TO_SUPPLIERS,
  INDICATOR_JUSTIFICATION_SUPPLIER_NOT_REPRESENTATIVE_TO_NATIVE_COMMUNITIES,
  INDICATOR_JUSTIFICATION_SUPPLIER_NOT_REPRESENTATIVE_TO_STAKEHOLDERS,
  INDICATOR_JUSTIFICATION_SUPPLIER_NOT_REPRESENTATIVE_TO_LOCAL_AUTHORITIES,
  INDICATOR_JUSTIFICATION_SUPPLIER_NOT_REPRESENTATIVE_TO_GOVERNMENT_AUTHORITIES,
  INDICATOR_JUSTIFICATION_SUPPLIER_NOT_RESPONSIBLE_FOR_TERRITORIAL_CONSTRAINTS,
  INDICATOR_JUSTIFICATION_PROJECT_DOES_NOT_AFFECT_NATIVE_COMMUNITIES,
  INDICATOR_JUSTIFICATION_PROJECT_DOES_NOT_AFFECT_STAKEHOLDERS,
  INDICATOR_JUSTIFICATION_PROJECT_NOT_LOCATED_ON_LOCAL_AUTHORITY_TERRITORY,
  INDICATOR_JUSTIFICATION_OTHER_REASON
]

export const DOCUMENT_SOURCE_USER = 'USER'
export const DOCUMENT_SOURCE_PRISMIC = 'PRISMIC'

export const QUESTION_TYPE_TEXT = 'TEXT'
export const QUESTION_TYPE_URL = 'URL'
export const QUESTION_TYPE_INTEGER = 'INTEGER'
export const QUESTION_TYPE_MONEY = 'MONEY'
export const QUESTION_TYPE_PERCENT = 'PERCENT'
export const QUESTION_TYPE_RICH_TEXT = 'RICH_TEXT'
export const QUESTION_TYPE_YES_NO = 'YES_NO'
export const QUESTION_TYPE_ATTACHMENT = 'ATTACHMENT'
export const QUESTION_TYPE_CONTEXT = 'CONTEXT'

export const USER_LANGUAGE_FRENCH = 'FRENCH'
export const USER_LANGUAGE_ENGLISH = 'ENGLISH'

export const CANADIAN_PROVINCE_CODES = ['AB', 'BC', 'MB', 'NB', 'NL', 'NT', 'NS', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT']
